'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OptInFeedback = require('./components/OptInFeedback.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OptInFeedback).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/opt-in/lib/components/opt-in-feedback/index.js
// module id = 1439
// module chunks = 1